import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const DiamondNavigation = () => {
  const facets = [
    { label: 'Scientific Program', route: '/program', color: '#FF6F4A', icon: '📚' },
    { label: 'Registration', route: '/registration', color: '#FFB6C1', icon: '🎫' },
    { label: 'Abstract Submission', route: '/abstracts', color: '#FF6F4A', icon: '📄' },
    { label: 'Faculty', route: '/faculty', color: '#FFB6C1', icon: '👨‍⚕️' },
    { label: 'Travel & Stay', route: '/travel', color: '#FF6F4A', icon: '✈️' },
    { label: 'Contact', route: '/contact', color: '#FFB6C1', icon: '📧' },
  ];

  return (
    <div className="w-full py-16" data-testid="diamond-navigation">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
        Explore <span className="gradient-text">Conference</span> Sections
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {facets.map((facet, index) => (
          <Link key={index} to={facet.route}>
            <div
              className="glass-card p-8 hover:scale-105 transition-transform duration-300 neon-glow group cursor-pointer"
              style={{ borderTop: `4px solid ${facet.color}` }}
              data-testid={`nav-card-${facet.label.toLowerCase().replace(/\\s+/g, '-')}`}
            >
              <div className="text-5xl mb-4">{facet.icon}</div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-[#FF6F4A] transition-colors">
                {facet.label}
              </h3>
              <ArrowRight className="h-5 w-5 text-[#FFB6C1] group-hover:translate-x-2 transition-transform" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DiamondNavigation;
